import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function GuaranteeFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-ivory py-12 md:py-20 px-4" data-id="element-82" data-mp="3petmxz76vw2b">
      <div className="max-w-3xl mx-auto" data-id="element-83" data-mp="3pd8uqg8ckp7m">
        <div className="bg-sand rounded-2xl border border-sand-deep px-5 py-6 md:px-8 md:py-8 flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 text-center sm:text-left" data-id="element-84" data-mp="3u61x4xgcflgj">
          <div className="w-20 h-20 rounded-full bg-sage-deep text-ivory flex flex-col items-center justify-center flex-shrink-0" data-id="element-85" data-mp="7y2azqghjlea">
            <span className="font-serif text-3xl font-bold leading-none" data-id="element-86" data-mp="cy6l8yqsvjw2">30</span>
            <span className="font-sans text-[10px] font-bold tracking-widest mt-0.5" data-id="element-87" data-mp="gy8p9ek0cpei">DÍAS</span>
          </div>
          <div data-id="element-88" data-mp="2eqcvqlfzqb8o">
            <p className="font-sans text-[11px] font-bold uppercase tracking-wider text-sage-deep" data-id="element-89" data-mp="2equp9ab9qbcw">
              Garantía de 30 días
            </p>
            <h2 className="mt-1 font-serif text-2xl md:text-3xl font-bold text-forest leading-tight" data-id="element-90" data-mp="vdw3aq3y0a99">
              Explora Pausa Propia con tranquilidad.
            </h2>
            <p className="mt-2 font-sans text-[15px] md:text-base text-forest/80 leading-[1.55]" data-id="element-91" data-mp="qkt7ebbp0opw">
              Accede, revisa los libros y prueba las primeras actividades. Si dentro de los primeros
              30 días consideras que no es para ti, puedes solicitar el reembolso según nuestra{' '}
              <a href="#politica-reembolso" className="underline underline-offset-2 text-terracotta-deep" data-id="element-92" data-mp="19d5hjk8l8ual">
                política publicada
              </a>
              .
            </p>
          </div>
        </div>

        <h2 className="mt-12 md:mt-14 font-serif text-[1.6rem] md:text-4xl font-bold text-center text-forest mb-6 md:mb-8 leading-tight" data-id="element-93" data-mp="zfh8dpa8jk8w">
          Antes de empezar
        </h2>

        <div className="space-y-2.5" data-id="element-94" data-mp="3k56m1yz7d000">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.q} className="bg-white rounded-xl border border-sand-deep" data-id="element-95" data-mp="2g7cp652z5kgi" data-mpi={index}>
                <h3 data-id="element-96" data-mp="2g50aq1wfds87">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-5 md:px-6 py-4 md:py-5 text-left flex justify-between items-center gap-4" data-id="element-97" data-mp="227tsq9jizxk1">
                    <span className="font-sans font-semibold text-[15px] md:text-lg text-forest" data-id="element-98" data-mp="1x9rzivsdyhuu">{faq.q}</span>
                    <PlusIcon className={`w-5 h-5 flex-shrink-0 text-terracotta transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-99" data-mp="1jezddehzq3fa" />
                  </button>
                </h3>
                <div id={panelId} className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-100" data-mp="uvxkkfw3veeo">
                  <div className="overflow-hidden" data-id="element-101" data-mp="14vy6m9ld08mk">
                    <div className="px-5 md:px-6 pb-5 space-y-2 font-sans text-[15px] text-forest/75 leading-[1.55]" data-id="element-102" data-mp="zur34mq91vlp">
                      {faq.a.map(p => <p key={p} data-id="element-103" data-mp="1dsyso9kyhumu">{p}</p>)}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}